import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { log } from '@/logger/logger';
import { I18N_KEYS } from '@/language/keys';
import { useGlobalStore } from '@/state/global.state';

const logger = log.getLogger('NodeInsertion');

export function useNodeInsertionError() {
  const { t } = useTranslation();
  const updateSnackbarData = useGlobalStore((state) => state.updateSnackbarData);

  return useCallback(
    (kind: 'paste' | 'template', error: unknown) => {
      logger.error('Node insertion failed', { kind, error });
      updateSnackbarData({
        text: t(
          kind === 'paste'
            ? I18N_KEYS.RECIPE_MAIN.ERRORS.PASTE_NODES_FAILED
            : I18N_KEYS.RECIPE_MAIN.ERRORS.INSERT_NODES_FAILED,
        ),
        severity: 'error',
        icon: null,
        isOpen: true,
      });
    },
    [t, updateSnackbarData],
  );
}
